import { useLocalCartUuid } from '@iheartjane/cart/utils';
import { useApplyPromoCode } from '@iheartjane/data-access/react-query';

import { selectEmbeddedApp } from '@jane/monolith/customer/redux/embeddedApp';
import { useCustomerSelector } from '@jane/monolith/customer/selectors';
import { getJwt } from '@jane/shared/auth';
import { useEcommApp } from '@jane/shared/providers';

/**
 * Flag-on promo apply via `POST /v3/carts/:uuid/promo_code`; `enabled` gates
 * the storage read, since hooks can't be conditional.
 */
export const useApplyLocalPromoCode = (enabled: boolean) => {
  const { appMode } = useEcommApp();
  const { partnerId } = useCustomerSelector(selectEmbeddedApp);
  const cartUuid = useLocalCartUuid(appMode, partnerId, enabled);
  const { isError, isSuccess, mutate, reset } = useApplyPromoCode();

  /** `false` when there is no cart yet: nothing was sent. */
  const apply = (promoCode: string) => {
    if (!enabled || !cartUuid) return false;

    mutate({ appMode, cartUuid, jwt: getJwt(), promoCode });
    return true;
  };

  return { apply, cartUuid, isError, isSuccess, reset };
};
